import { render } from "./CompanyCard.vue?vue&type=template&id=419882fc&ts=true"
import script from "./CompanyCard.vue?vue&type=script&lang=ts"
export * from "./CompanyCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__